import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, Inject, AfterViewInit, ViewChild, ElementRef, AfterContentChecked, ChangeDetectorRef } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import * as fromStore from '@ibe.components/shared/sidebar-views/passengers-details/_store';
import * as fromStoreGlobal from '../../../../store';
import { Store } from '@ngrx/store';
import { filter, map, take, takeWhile } from 'rxjs/operators';
import * as _ from 'lodash';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions } from '@ngrx/effects';
import { SidebarService, ScreenService } from '@ibe/services/ui';
import * as fromMainStore from '../../../../store';
import { DOCUMENT } from '@angular/common';
import { PageScrollService } from 'ngx-page-scroll-core';

import { INDRABookedTripDetails } from '@ibe.models/booked-trip-details.indra.model.lib';
import { INDRAInfoPax } from '@ibe.models/pnr-data.indra.model.lib';
import { INDRAPax } from '@ibe.models/pax.indra.model.lib';
import { PassengerDetailEmergencyContactComponent } from
	'@ibe.components/shared/sidebar-views/passengers-details/passengers-details-indra/passenger-detail-emergency-contact/passenger-detail-emergency-contact.component';
import { PassengerDetailPersonalDocumentsComponent } from
	'@ibe.components/shared/sidebar-views/passengers-details/passengers-details-indra/passenger-detail-personal-documents/passenger-detail-personal-documents.component';
import { FrequentFlyerComponent } from
	'@ibe.components/shared/sidebar-views/passengers-details/passengers-details-indra/frequent-flyer/frequent-flyer.component';
// import { PassengerDetailContactsComponent } from '@ibe.components/shared/sidebar-views/passengers-details/passengers-details-indra/passenger-detail-contacts/passenger-detail-contacts.component';
import { INDRAPassengerDetailMainInfoComponent } from
	'@ibe.components/shared/sidebar-views/passengers-details/passengers-details-indra/passenger-detail-main-info/passenger-detail-main-info.indra.component';
import { INDRAPassengerDetailStudentComponent } from '@ibe.components/shared/sidebar-views/passengers-details/passengers-details-indra/passenger-detail-student/passenger-detail-student.indra.component';
import { INDRAPassengerDetailResidentComponent } from '@ibe.components/shared/sidebar-views/passengers-details/passengers-details-indra/passenger-detail-resident/passenger-detail-resident.indra.component';
import { INDRAPassengerDetailWorkComponent } from '@ibe.components/shared/sidebar-views/passengers-details/passengers-details-indra/passenger-detail-work/passenger-detail-work.indra.component';
import { INDRAPassengerDetailChubbComponent } from '@ibe.components/shared/sidebar-views/passengers-details/passengers-details-indra/passenger-detail-chubb/passenger-detail-chubb.indra.component';

import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { FormGroupService } from '@ibe.services/form-group.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { INDRAParallelService } from '@ibe.services/parallel.indra.service';

import {
	TAP_MILES_AND_GO_FF_TIER_LEVELS,
	TAP_MILES_AND_GO_GOLD,
	TAP_MILES_AND_GO_MILES,
	TAP_MILES_AND_GO_MILS,
	TAP_MILES_AND_GO_NAVIGATOR,
	TAP_MILES_AND_GO_SILVER,
	PAX_TYPE_INFANT_CODE,
	PAX_TYPE_CHILD_CODE,
	COOKIES_VAR_KEY_PASSENGER_DETAILS,
	COOKIES_VAR_KEY_PASSENGER_CONTACT_DETAILS,
	PAX_FF_MISMATCHNAME_ERROR_KEY,
	COUNTRY_CODE_BRAZIL,
	COUNTRY_CODE_PORTUGAL,
	COUNTRY_CODE_USA,
	PERSONAL_DOC_API_ORIGIN_DEST_COUNTRIES,
	PERSONAL_DOC_API_PT_COUNTRY_ORIGIN_EXCEPTIONS,
	PERSONAL_DOC_EUROPE_COUNTRY_CODES,
	TRIP_TYPE_ROUND_TRIP,
	TRIP_TYPE_ONE_WAY,
	TRIP_TYPE_MULTICITY,
	DEFAULT_MARKET,
	INSURANCE_INFO_REQUIRED_MARKETS,
	DOCUMENT_NUMBER_NATIONAL_IDENTITY_CARD,
	COUNTRY_CODE_UNITED_KINGDOM,
	PERSONAL_DOC_API_DEST_COUNTRIES_EXCEPTIONS,
	PAX_TYPE_SPONSOR,
	EMPTY_SPACE,
	SESSION_VAR_KEY_LANGUAGE,
	PERSONAL_DOC_API_REQUIRED_COUNTRIES
} from '@ibe.config';
import { CookieService } from 'ngx-cookie-service';
import { PAX_TYPE_ADULT_CODE, PAX_TYPE_YOUNG_ADULT_CODE } from '@ibe.config';
import { INDRADateValidtyService } from '@ibe.services/date-validity.indra.service';
import { INDRADateService } from '@ibe.services/date.indra.service';
import { INDRALocationsTranslations } from '@ibe.models/translate.indra.model.lib';
import { TimeoutSvcService } from '@ibe.services/timeout-svc.service';
import { INDRAGoogleAnalyticsService } from '@ibe.services/google.analytics.indra.service';
import { FrequentFlyerIndraService } from '@ibe.services/frequent-flyer-indra.service';
import { BeneficiaryIndraService } from '@ibe.services/beneficiary-indra.service';

@Component({
	selector: 'app-passengers-new',
	templateUrl: './passengers-new.indra.component.html',
	styleUrls: ['./passengers-new.component.scss']
})
export class INDRAPassengersNewComponent implements OnInit, AfterContentChecked, OnDestroy {

	@ViewChild(PassengerDetailEmergencyContactComponent) emergencyContactComp: PassengerDetailEmergencyContactComponent;
	@ViewChild(PassengerDetailPersonalDocumentsComponent) personalDocsComp: PassengerDetailPersonalDocumentsComponent;
	@ViewChild(FrequentFlyerComponent) frequentFlyerComp: FrequentFlyerComponent;
	// @ViewChild(PassengerDetailContactsComponent) passengerContactsComp: PassengerDetailContactsComponent;
	@ViewChild(INDRAPassengerDetailMainInfoComponent) passengerMainInfoComp: INDRAPassengerDetailMainInfoComponent;
	@ViewChild(INDRAPassengerDetailStudentComponent) passengerStudentComp: INDRAPassengerDetailStudentComponent;
	@ViewChild(INDRAPassengerDetailResidentComponent) passengerResidentComp: INDRAPassengerDetailResidentComponent;
	@ViewChild(INDRAPassengerDetailWorkComponent) passengerWorkComp: INDRAPassengerDetailWorkComponent;
	@ViewChild(INDRAPassengerDetailChubbComponent) passengerTravelInsuranceComp: INDRAPassengerDetailChubbComponent;

	@ViewChild('mainInfo', { read: ElementRef }) mainInfo: ElementRef;
	@ViewChild('personalDocs', { read: ElementRef }) personalDocs: ElementRef;
	@ViewChild('emergencyContact', { read: ElementRef }) emergencyContact: ElementRef;
	@ViewChild('studentInfo', { read: ElementRef }) studentInfo: ElementRef;
	@ViewChild('residentInfo', { read: ElementRef }) residentInfo: ElementRef;
	@ViewChild('frequentFlyerInfo', { read: ElementRef }) frequentFlyerInfo: ElementRef;
	@ViewChild('insuranceInfo', { read: ElementRef }) insuranceInfo: ElementRef;
	@ViewChild('workInfo', { read: ElementRef }) workInfo: ElementRef;

	public showSave = false;
	public notif: any;
	public isMobile: boolean = false;
	public hasInsurance: boolean = false;
	public hasImportedData: boolean = false;
	private isAlive: boolean = true;
	private userData: any;

	private CAP_BENEFICIARIES_NUMBER: number = 10;
	private numberOfBeneficiaries: number;
	private paxSalutations: any[];
	private beneficiaryList: any[];
	private beneficiaryNames: any[] = [];
	private beneficiarySelected: string;
	private passengers: any[];
	private beneficiaryListSubscription: Subscription;
	//private sameNameFlag: boolean = false;
	private edit: boolean = this.route.snapshot.paramMap.get('edit').toLowerCase() == 'true';
	private isAward: boolean = this.route.snapshot.paramMap.get('isAward').toLowerCase() == 'true';
	private isNew: boolean = this.route.snapshot.paramMap.get('isNew').toLowerCase() == 'true';
	private idPax: string = this.route.snapshot.paramMap.get('id');

	private bookedTrip: INDRABookedTripDetails;
	private pnr: string;
	private _saving = false;
	private _passengerInfo: INDRAPax;
	private _loyaltyLogo: string;
	private _logoClasses: string;
	private _displayValidationMessages: boolean = false;

	private subs$ = new Subscription();
	private passengerInfo$: Observable<INDRAPax> = this.store.select(fromStore.getSelectedPassengersAtIndex);
	public anyFormHasChanges$: Observable<any> = this.store.select(fromStore.getSelectedAnyFormHasChanges).pipe(
		filter(data => !_.isEmpty(data)),
		map(obj => _.reduce(obj, (i, val, k) => val && !(i[k] = val) || i, {}))
	);

	private userInfo$: Observable<any> = this.mainStore.select(fromMainStore.getUserInfo);
	private userInfo: any;

	private studentDiscountSelected$: Observable<any> = this.mainStore.select(fromMainStore.getFlightsFilterStudentPassenger);
	public studentDiscountSelected: boolean = false;

	private residentDiscountSelected$: Observable<any> = this.mainStore.select(fromMainStore.getFlightsFilterLiveAzoresMadeiraPassenger);
	public residentDiscountSelected: boolean = false;

	userInfoCookie: any;
	saved: string = 'false';
	hasCookies: boolean = false;
	dataFromCookie: boolean = false;
	idPaxFFLevelMap: any;
	errorMessage: string = '';
	paxSectionWithError: any = [];
	isBrazilOrigin: boolean = false;
	requireAPISection: boolean = false;
	mainPax: boolean = false;
	textEnd: string = ".";

	// showForm: boolean = false;
	// newEmployee: boolean = true;
	// userEmployee: String = '';
	// isCorporate$: Observable<boolean> = this.store.select(fromStore.getIsCorporate);
	isCorporate: boolean = false;
	isBrazilOriginDestination: boolean = false;
	/*
	employees = [
		{ label: 'Choose other passenger', value: '' },
		{ label: 'Mr. Francisco Cabral (fcabral@sonae.com)', value: 'fcabral' },
		{ label: 'Mrs. Ana Patrícia Santos (apsantos@sonae.com)', value: 'apsantos' },
		{ label: 'Mr. Antonio Silva (asilva@sonae.com)', value: 'asilva' },
		{ label: 'Dr. Maria Sayonara (msayonara@sonae.com)', value: 'msayonara' },
		{ label: 'Mr. Mário Rodrigues (mrodrigues@sonae.com)', value: 'mrodrigues' },
		{ label: 'Mrs. Nádia Ferreira (nferreira@sonae.com)', value: 'nferreira' },
		{ label: 'Mrs. Olívia Palmira (opalmira@sonae.com)', value: 'opalmira' },
		{ label: 'Mr. Rui Pinto (rpinto@sonae.com)', value: 'rpinto' }
	];
	*/

	market$: Observable<any> = this.globalStore.select(fromStoreGlobal.getUserMarket);
	market: string = '';

	userLanguage$: Observable<any> = this.globalStore.select(fromStoreGlobal.getUserLanguage);
	userLanguage: number = -1; // Style guide EN = 0 and PT = 1

	insuranceFormShow: { vat_info: boolean, address_info: boolean } = null;
	bookingOwner = false; // Reference to first adult used when insurance was bought and requires specific contact details


	get displayValidationMessages(): boolean {
		return this._displayValidationMessages;
	}

	get saving(): boolean {
		return this._saving;
	}

	get passengerInfo(): INDRAPax {
		return this._passengerInfo;
	}

	get passengerName(): string {
		if (_.isNil(this.passengerInfo) || _.isNil(this.passengerInfo.surname)) return '';
		if (isNaN(this.passengerInfo.surname as any)) {
			let paxName = '';
			if (!_.isNil(this.passengerInfo.title))
				paxName += this.passengerInfo.title;
			if (!_.isNil(this.passengerInfo.name))
				paxName += (paxName.length > 0 ? ' ' + this.passengerInfo.name : this.passengerInfo.name);
			if (!_.isNil(this.passengerInfo.surname))
				paxName += (paxName.length > 0 ? ' ' + this.passengerInfo.surname : this.passengerInfo.surname);
			return paxName;
		} else {
			const key = 'addMoreSidebars.passenger.label.' + this.passengerInfo.typePax; // TODO change to correct translation key
			return this.INDRA_getTextTranslation(key) + ' ' + this.passengerInfo.surname;
		}
	}

	get notInfant(): boolean {
		return !Object.is(PAX_TYPE_INFANT_CODE, this.passengerInfo.typePax);
	}

	get notChild(): boolean {
		return !Object.is(PAX_TYPE_CHILD_CODE, this.passengerInfo.typePax);
	}

	get _hasFrequentFlyer(): boolean {
		return ((this.passengerInfo.tierLevelFF)
			&& TAP_MILES_AND_GO_FF_TIER_LEVELS.includes(this.passengerInfo.tierLevelFF));
	}

	get loyaltyLogo(): string {
		if (_.isNil(this._loyaltyLogo)) {
			switch (this.passengerInfo.tierLevelFF) {
				case TAP_MILES_AND_GO_MILES:
				case TAP_MILES_AND_GO_MILS:
					this._loyaltyLogo = 'loyalty--miles_go';
					break;
				case TAP_MILES_AND_GO_SILVER:
					this._loyaltyLogo = 'loyalty--miles_go_silver';
					break;
				case TAP_MILES_AND_GO_GOLD:
					this._loyaltyLogo = 'loyalty--miles_go_gold';
					break;
				case TAP_MILES_AND_GO_NAVIGATOR:
					this._loyaltyLogo = 'loyalty--navigator';
					break;
				default:
					this._loyaltyLogo = '';
			}
		}
		return this._loyaltyLogo;
	}

	get logoClasses(): string {
		if (_.isNil(this._logoClasses)) {
			switch (this.passengerInfo.tierLevelFF) {
				case TAP_MILES_AND_GO_MILES:
				case TAP_MILES_AND_GO_MILS:
					this._logoClasses = 'logo__miles-go';
					break;
				case TAP_MILES_AND_GO_SILVER:
					this._logoClasses = 'logo__miles-go-silver';
					break;
				case TAP_MILES_AND_GO_GOLD:
					this._logoClasses = 'logo__miles-go-gold';
					break;
				case TAP_MILES_AND_GO_NAVIGATOR:
					this._logoClasses = 'logo__navigator';
					break;
				default:
					this._logoClasses = '';
			}
		}
		return this._logoClasses;
	}

	departureDate = "";
	showInsurance = false;
	isUKDestination: boolean = false;
	private locations: INDRALocationsTranslations[] = [];
	isReset: boolean = false;

	private triggerCreatePassenger$: Observable<boolean> = this.parallelService.triggerCreatePassenger$;
	private triggerCreateContact$: Observable<boolean> = this.parallelService.triggerCreateContact$;

	triggerCreatePassenger: boolean = false;
	triggerCreateContact: boolean = false;

	constructor(
		private store: Store<fromStore.State>,
		private globalStore: Store<fromStoreGlobal.State>,
		private mainStore: Store<fromMainStore.State>,
		private fb: FormBuilder,
		private route: ActivatedRoute,
		private screen: ScreenService,
		private actions$: Actions,
		private sidebarService: SidebarService,
		private fbService: FormGroupService,
		private bfmStorage: INDRABFMDataStorageService,
		private ibeAdminService: INDRAIbeAdminService,
		private storage: INDRAStorageService,
		private cookieService: CookieService,
		private pageScrollService: PageScrollService,
		private bookingService: INDRABookingService,
		private parallelService: INDRAParallelService,
		private dateValidityService: INDRADateValidtyService,
		private dateService: INDRADateService,
		private timeoutSvc: TimeoutSvcService,
		private googleAnalytics: INDRAGoogleAnalyticsService,
		private frequentFlyerIndraService: FrequentFlyerIndraService,
		private beneficiaryService: BeneficiaryIndraService,
		private cdref: ChangeDetectorRef,
		@Inject(DOCUMENT) private document: any,
	) {
		this.screen.isMobile().subscribe(value => {
			this.isMobile = value;
		});
	}

	ngOnInit() {
		this.bookedTrip = this.bfmStorage.INDRA_getActiveBookedTrip();
		this.pnr = this.bookedTrip.data.pnr;
		this.hasInsurance = (this.bookedTrip['insurance']) ? true : false;
		this.isBrazilOrigin = this.INDRA_isBrazilOrigin();
		this.isBrazilOriginDestination = this.INDRA_isBrazilOriginDestination();
		this.requireAPISection = this.INDRA_isAPISectionRequired();
		this.departureDate = this.INDRA_getDepartureDate();

		// this.showInsurance = this.INDRA_showTravelInsuranceForm();

		this.INDRA_setInsuranceForm();

		const passengerIndex = parseInt(this.idPax, 10) - 1;
		this.bookingOwner = passengerIndex === 0;

		// this.saved = this.route.snapshot.paramMap.get('saved');

		/* note: from post-sprint 8 client code merge
		this.isCorporate$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(data => {
				this.isCorporate = data;
			});
		*/

		this.market$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(values => {
				this.market = values;
				this.INDRA_setInsuranceForm();
			});

		this.userLanguage$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(values => {
				this.userLanguage = values;
				this.INDRA_setInsuranceForm(); 
			})

		this.userInfo$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(data => {
				this.userInfo = data;
				this.userData = this.storage.get('userData');
			});

		this.subs$.add(
			this.studentDiscountSelected$.pipe(take(1)).subscribe(data => {
				this.studentDiscountSelected = data;
			})
		);

		this.subs$.add(
			this.residentDiscountSelected$.pipe(take(1)).subscribe(data => {
				this.residentDiscountSelected = data;
			})
		);

		this.subs$.add(
			this.passengerInfo$.subscribe(data => {
				this._passengerInfo = data;
			})
		);

		this.subs$.add(
			this.store.select(
				fromStore.getSelectedNotif
			).subscribe(data => {
				this._saving = false;
				this.notif = data;
				this._displayValidationMessages = false;

				if (this.notif && this.notif['message'] && this.notif['message'].length) {
					this.googleAnalytics.IBE_GA_PassengerError(this.notif['message'][0]);
				}
			})
		);

		this.subs$.add(
			this.actions$.pipe(
				filter(action => Object.is(fromStore.ActionTypes.SAVE_PASSENGER_SUCCESS, action.type))
			).subscribe((action: any) => {
				this._saving = false;
				this.store.select(
					fromStore.getSelectedBookedTripInfoPax
				).pipe(
					take(1)
				).subscribe((data: INDRAInfoPax) => {
					const error = action.payload.res['passenger-tier-level-info'] ? action.payload.res['passenger-tier-level-info'][action.payload.rq.passenger_id] : undefined;
					if (error === PAX_FF_MISMATCHNAME_ERROR_KEY) {
						this.errorMessage = PAX_FF_MISMATCHNAME_ERROR_KEY;
					} else {
						this.bfmStorage.INDRA_setActiveBookInfoPax(data);
						this.sidebarService.closeSidebar(true);
					}
				});
			})
		);

		this.subs$.add(
			this.store.select(fromStore.getSelectedBookedTripLocations).subscribe(data => this.locations = Object.values(data))
		);

		this.subs$.add(
			this.triggerCreatePassenger$.subscribe(value => {
				this.triggerCreatePassenger = value;
			})
		);

		this.subs$.add(
			this.triggerCreateContact$.subscribe(value => {
				this.triggerCreateContact = value;
			})
		);

		const passengerDetails = this.cookieService.check(COOKIES_VAR_KEY_PASSENGER_DETAILS);

		if (passengerDetails) {
			this.userInfoCookie = JSON.parse(atob(this.cookieService.get(COOKIES_VAR_KEY_PASSENGER_DETAILS)));
			let paxCookieData = this.userInfoCookie.find(info => info.idPax == this.passengerInfo.idPax);

			if (!paxCookieData) {
				paxCookieData = this.userInfoCookie.find(info => info.typePax == this.passengerInfo.typePax);
			}
			if (paxCookieData) {
				this.hasCookies = true;
			}
		}

		if (this.bookedTrip.data.infoPax && this.bookedTrip.data.infoPax.listPax) {
			const listPax = this.bookedTrip.data.infoPax.listPax;
			const adt = listPax.find(pax => pax.typePax === PAX_TYPE_ADULT_CODE);
			const mainPax = adt ? adt : listPax.find(pax => pax.typePax === PAX_TYPE_YOUNG_ADULT_CODE);
			this.mainPax = mainPax && mainPax.idPax === this._passengerInfo.idPax ? true : false;
		}

		this.INDRA_isUKDestination(this.bookedTrip.data.fare)

		this.INDRA_loadBeneficiaryList();
	}

	ngOnDestroy() {
		this.beneficiaryListSubscription.unsubscribe();
		this.isAlive = false;
		this.subs$.unsubscribe();
		this.onClose();
	}

	ngAfterViewInit() {
		this.subs$.add(
			this.anyFormHasChanges$.pipe(
				filter(data => !_.isEmpty(data))
			).subscribe(() => setTimeout(() => this.showSave = Boolean(true)))
		);
		this.subs$.add(
			this.anyFormHasChanges$.pipe(
				filter(data => _.isEmpty(data))
			).subscribe(() => setTimeout(() => this.showSave = Boolean(false)))
		);
		// Import user info automatically of data stored on "Cookies"
		if (this.hasCookies && !this.userInfo && this.passengerInfo.listTravelDoc.length == 0) {
			this.userInfoCookie = JSON.parse(atob(this.cookieService.get(COOKIES_VAR_KEY_PASSENGER_DETAILS)));
			this.INDRA_importUserData('cookie');
		}
		if (this.componentAndFormExists(this.passengerMainInfoComp) && this.userData) {
			let currentBeneficiaryFormatted = this.passengerMainInfoComp.form.controls['title'].value + EMPTY_SPACE + this.passengerMainInfoComp.form.controls['name'].value + EMPTY_SPACE + this.passengerMainInfoComp.form.controls['surname'].value;
			this.INDRA_unmarkBeneficiaryAsUsed(currentBeneficiaryFormatted);

			//If the current passenger being edited is also new to the list, this allows to edit de passenger's data
			if (this.isNew && this.edit) {
				this.passengerMainInfoComp.form.controls['isNew'].setValue(true);
				this.INDRA_enableFormFields();
			} else if (!this.isNew && this.edit) {
				// this.INDRA_disableFormFields();
				this.passengerMainInfoComp.form.controls['isNew'].setValue(false);
			} else if (this.isNew && !this.edit) {
				this.passengerMainInfoComp.form.controls['isNew'].setValue(true);
			}
		}


		if (Number(this.numberOfBeneficiaries) >= this.CAP_BENEFICIARIES_NUMBER) {
			this.INDRA_disableFormFields();
		}
	}

	ngAfterContentChecked() {
		this.cdref.detectChanges();

	}

	INDRA_setInsuranceForm() {
		if (this.bookingOwner) {
			if (this.bookedTrip && this.market) {
				const marketCountryCode = this.market.trim();
				if (this.bookedTrip.insurance) {
					if (marketCountryCode === 'IT') {
						this.insuranceFormShow = { vat_info: true, address_info: false };
						this.showInsurance = true;
					} else if (marketCountryCode === 'PT') {
						this.insuranceFormShow = { vat_info: true, address_info: true };
						this.showInsurance = true;
					} else {
						this.showInsurance = false;
					}
				}
			}
		}
		else {
			this.showInsurance = false;
		}
	}

	INDRA_loadBeneficiaryList() {
		this.beneficiaryService.currentBeneficiaryList$.subscribe(beneficiaryList => this.beneficiaryList = beneficiaryList);
		this.beneficiaryService.currentNumberOfBeneficiaries$.subscribe(numberOfBeneficiaries => this.numberOfBeneficiaries = numberOfBeneficiaries);
		this.beneficiaryService.currentPaxSalutations$.subscribe(paxSalutations => this.paxSalutations = paxSalutations);
		this.INDRA_receiveBeneficiaryNames();
	}

	INDRA_isBrazilOrigin() {
		const originCountries = this.bookingService.INDRA_getOriginCountry(this.bookedTrip);
		return ((originCountries && originCountries.length > 0) ? ((originCountries.filter(country => country == COUNTRY_CODE_BRAZIL)).length > 0) : (false));
	}

	INDRA_isBrazilOriginDestination() {
		let isBrazilOriginOrDestination = false;
		const destinationCountries = this.bookingService.INDRA_getArrivalCountry(this.bookedTrip, true);
		const originCountries = this.bookingService.INDRA_getOriginCountry(this.bookedTrip);
		isBrazilOriginOrDestination = destinationCountries.includes(COUNTRY_CODE_BRAZIL) || originCountries.includes(COUNTRY_CODE_BRAZIL);
		return isBrazilOriginOrDestination;
	}

	INDRA_isAPISectionRequired() {
		let isRequired = false;
		// (1) when origin/destination involves the ff countries
		const countriesInBooking = this.bookingService.INDRA_getBookingTripCountries(this.bookedTrip);
		if (countriesInBooking && countriesInBooking.length > 0) {
			countriesInBooking.forEach(country => {
				if (PERSONAL_DOC_API_ORIGIN_DEST_COUNTRIES.includes(country)) {
					isRequired = true;
				}
			});
		}

		// check for destination countries that do not require API docs
		const countriesDestination = this.bookingService.INDRA_getArrivalCountry(this.bookedTrip, true);
		const countriesOrigin = this.bookingService.INDRA_getOriginCountry(this.bookedTrip);
		const isDestinationExempted = countriesDestination && countriesDestination.length ?
			countriesDestination.some(destination => PERSONAL_DOC_API_DEST_COUNTRIES_EXCEPTIONS.includes(destination)) : false;
		// exception to this rule is if USA origin
		const isUSAOrigin = countriesOrigin && countriesOrigin.length ? countriesOrigin.some(origin => origin === COUNTRY_CODE_USA) : false;
		if (isDestinationExempted && !isUSAOrigin) isRequired = false;

		// (2) When travelling to Portugal (including stops) and departing from europe except for specific countries
		if (!isRequired) {
			const destinationCountries = this.bookingService.INDRA_getArrivalCountry(this.bookedTrip, true);
			const originCountries = this.bookingService.INDRA_getOriginCountry(this.bookedTrip);
			if (destinationCountries && destinationCountries.length > 0 && destinationCountries.includes(COUNTRY_CODE_PORTUGAL)) {
				let isOriginEurope = false;
				let isException = false;
				if (originCountries && originCountries.length > 0) {
					originCountries.forEach(country => {
						if (PERSONAL_DOC_EUROPE_COUNTRY_CODES.includes(country)) {
							isOriginEurope = true;
						}
						if (PERSONAL_DOC_API_PT_COUNTRY_ORIGIN_EXCEPTIONS.includes(country)) {
							isException = true;
						}
					});
				}
				if (isOriginEurope && !isException) {
					isRequired = true;
				}
			}
		}

		if(isRequired) {
			if (countriesDestination.some(destination => PERSONAL_DOC_API_REQUIRED_COUNTRIES.includes(destination))) {
				isRequired = true;
			} else if (countriesOrigin.some(origin => PERSONAL_DOC_API_REQUIRED_COUNTRIES.includes(origin))) {
				isRequired = true;
			} else {
				isRequired = false;
			}
		}

		return isRequired;
	}

	public saveSidebar() {
    if (this._saving || this.parallelService.isGenerateApiLoading || this.parallelService.isCatalogueApiLoading) {
      return;
    }

		if (this.isAward) {
			this.INDRA_matchesNames();
		}
		//this.INDRA_markBeneficiaryAsUsed();
		this.INDRA_enableFormFields();
		this.anyFormHasChanges$
			.pipe(take(1))
			.subscribe(data => {
				if (this.validateForms(data)) {
					this._saving = true;
					this._displayValidationMessages = false;
					this.timeoutSvc.isOtherAPILoading$.next(true);
					this.store.dispatch(
						new fromStore.SaveNewPassenger({
							...data,
							emergencyContact: this.componentAndFormExists(this.emergencyContactComp) ? this.emergencyContactComp.form.value : null,
							travelDocument: this.componentAndFormExists(this.personalDocsComp) ? this.personalDocsComp.form.value : {},
							frequentFlyer: this.componentAndFormExists(this.frequentFlyerComp) ? this.frequentFlyerComp.form.value : {},
							contact: /* this.componentAndFormExists(this.passengerContactsComp) ? this.passengerContactsComp.form.value : */ {},
							mainInfo: this.componentAndFormExists(this.passengerMainInfoComp) ? this.passengerMainInfoComp.form.value : {},
							studentInfo: this.componentAndFormExists(this.passengerStudentComp) ? this.passengerStudentComp.form.value : {},
							residentInfo: this.componentAndFormExists(this.passengerResidentComp) ? this.passengerResidentComp.form.value : {},
							workInfo: this.componentAndFormExists(this.passengerWorkComp) ? this.passengerWorkComp.form.value : {},
							travelInsurance: this.componentAndFormExists(this.passengerTravelInsuranceComp) ? this.passengerTravelInsuranceComp.form.value : {}
						}, this.passengerInfo.idPax, this.passengerInfo.typePax)
					);
					if (this.passengerMainInfoComp.form.controls['isNew'].value) {
						this.numberOfBeneficiaries = Number(this.numberOfBeneficiaries) + 1;
						this.beneficiaryService.setNumberOfBeneficiaries(this.numberOfBeneficiaries);
					} else {
						//this.INDRA_disableFormFields();
					}
				} else {
					this._saving = false;
					this._displayValidationMessages = true;

					for (const section of this.paxSectionWithError) {
						if (section) {
							switch (section) {
								case '#mainInfo':
									this.INDRA_scrollToElement(this.mainInfo);
									break;
								case '#personalDocs':
									this.INDRA_scrollToElement(this.personalDocs);
									break;
								case '#emergencyContact':
									this.INDRA_scrollToElement(this.emergencyContact);
									break;
								case '#studentInfo':
									this.INDRA_scrollToElement(this.studentInfo);
									break;
								case '#residentInfo':
									this.INDRA_scrollToElement(this.residentInfo);
									break;
								case '#frequentFlyerInfo':
									this.INDRA_scrollToElement(this.frequentFlyerInfo);
									break;
								case '#insuranceInfo':
									this.INDRA_scrollToElement(this.insuranceInfo);
									break;
								case '#workInfo':
									this.INDRA_scrollToElement(this.workInfo);
									break;
								default:
									this.INDRA_scrollToElement(this.mainInfo);
							}

							break;
						}
					}
					if (Number(this.numberOfBeneficiaries) >= this.CAP_BENEFICIARIES_NUMBER || !this.isNew) {
						//this.INDRA_disableFormFields();
					}
				}
			});
	}

	private componentAndFormExists(component: any): boolean {
		return !_.isNil(component) && !_.isNil(component.form);
	}

	public onClose() {
		this.store.dispatch(new fromStore.CancelEditing());
	}

	public hideNotifications() {
		this.store.dispatch(new fromStore.HideNotificationAction());
	}

	private validateForms(tags: any): boolean {
		const isValid = [];
		this.paxSectionWithError = [];
		Object.keys(tags).forEach(key => {
			switch (key) {
				case 'updateDocument':
				case 'updateDoca':
				case 'updateRedress': {
					if (this.personalDocsComp) {
						this.fbService.markFormAsTouched(this.personalDocsComp.form);
						isValid.push(this.personalDocsComp.form.valid);
						if (!this.personalDocsComp.form.valid)
							this.paxSectionWithError.push('#personalDocs');
					}
					break;
				}
				case 'updateEmergencyContact': {
					this.fbService.markFormAsTouched(this.emergencyContactComp.form);
					isValid.push(this.emergencyContactComp.form.valid);
					if (!this.emergencyContactComp.form.valid)
						this.paxSectionWithError.push('#emergencyContact');
					break;
				}
				/*
				case 'updateContact': {
					this.fbService.markFormAsTouched(this.passengerContactsComp.form);
					isValid.push(this.passengerContactsComp.form.valid);
					if (!this.passengerContactsComp.form.valid) 
						this.paxSectionWithError.push('#contactInfo');
					break;
				}
				*/
				case 'updateFrequentFlyer': {
					this.fbService.markFormAsTouched(this.frequentFlyerComp.form);
					isValid.push(this.frequentFlyerComp.form.valid);
					if (!this.frequentFlyerComp.form.valid)
						this.paxSectionWithError.push('#frequentFlyerInfo');
					break;
				}
				case 'updateMainInfo': {
					this.fbService.markFormAsTouched(this.passengerMainInfoComp.form);
					isValid.push(this.passengerMainInfoComp.form.valid);
					if (!this.passengerMainInfoComp.form.valid)
						this.paxSectionWithError.push('#mainInfo');
					break;
				}
				case 'updateStudentInfo': {
					this.fbService.markFormAsTouched(this.passengerStudentComp.form);
					isValid.push(this.passengerStudentComp.form.valid);
					if (!this.passengerStudentComp.form.valid)
						this.paxSectionWithError.push('#studentInfo');
					break;
				}
				case 'updateResidentInfo': {
					this.fbService.markFormAsTouched(this.passengerResidentComp.form);
					isValid.push(this.passengerResidentComp.form.valid);
					if (!this.passengerResidentComp.form.valid)
						this.paxSectionWithError.push('#residentInfo');
					break;
				}
				case 'updateWorkInfo': {
					this.fbService.markFormAsTouched(this.passengerWorkComp.form);
					isValid.push(this.passengerWorkComp.form.valid);
					if (!this.passengerWorkComp.form.valid)
						this.paxSectionWithError.push('#workInfo');
					break;
				}
				case 'updateTravelInsurance': {
					this.fbService.markFormAsTouched(this.passengerTravelInsuranceComp.form);
					isValid.push(this.passengerTravelInsuranceComp.form.valid);
					if (!this.passengerTravelInsuranceComp.form.valid)
						this.paxSectionWithError.push('#insuranceInfo');
					break;
				}
				default:
					isValid.push(false);
			}
		});

		return (isValid.filter(item => item == false).length === 0);
	}

	INDRA_printLoggedInName(user) {
		if (user && user.firstName && user.lastName) {
			return (user.firstName + ' ' + user.lastName);
		} else {
			return 'Adult 1';
		}
	}

	INDRA_importUserData(source) {
		this.passengerMainInfoComp.form.controls['isNew'].setValue(false);
		if (this.userData || this.hasCookies) {
			const useCookies: boolean = source === 'cookie';
			if (this.passengerInfo.typePax == PAX_TYPE_INFANT_CODE || this.passengerInfo.typePax == PAX_TYPE_CHILD_CODE || this.passengerInfo.typePax == PAX_TYPE_YOUNG_ADULT_CODE) {
				const departureDate = new Date(this.departureDate);
				const isValidDate = this.dateValidityService.INDRA_checkValidBirthDate(this.passengerInfo.typePax, departureDate, this.userData.userProfile.dateOfBirth);

				if (!isValidDate) {
					this.userData.userProfile.dateOfBirth = null;
				}
			}

			if (useCookies) {
				let paxCookieData = this.userInfoCookie.find(info => info.idPax == this.passengerInfo.idPax && info.typePax == this.passengerInfo.typePax);

				if (!paxCookieData) {
					paxCookieData = this.userInfoCookie.find(info => info.typePax == this.passengerInfo.typePax);
				}

				this.dataFromCookie = true;

				// main info form
				if (this.componentAndFormExists(this.passengerMainInfoComp)) {
					this.passengerMainInfoComp.form.controls['name'].setValue(paxCookieData.name || '');
					this.passengerMainInfoComp.form.controls['surname'].setValue(paxCookieData.surname || '');
					this.passengerMainInfoComp.form.controls['title'].setValue(paxCookieData.title || null);
					this.passengerMainInfoComp.form.controls['gender'].setValue(paxCookieData.listTravelDoc[0].gender || null);
					this.passengerMainInfoComp.form.controls['birthDate'].setValue(paxCookieData.listTravelDoc[0].birthDate || null);

					this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateMainInfo': true }));
				}

				// personal travel document form
				if (this.componentAndFormExists(this.personalDocsComp)) {
					this.personalDocsComp.form.controls['gender'].setValue(paxCookieData.listTravelDoc[0].gender || null);
					this.personalDocsComp.form.controls['birthDate'].setValue(paxCookieData.listTravelDoc[0].birthDate || null);
					this.personalDocsComp.form.controls['nationallity'].setValue(paxCookieData.listTravelDoc[0].nationallity || null);

					if (!(this.isUKDestination && paxCookieData.listTravelDoc[0].docType === DOCUMENT_NUMBER_NATIONAL_IDENTITY_CARD)) {
						this.personalDocsComp.form.controls['docType'].setValue(paxCookieData.listTravelDoc[0].docType || null);
						this.personalDocsComp.form.controls['docNum'].setValue(paxCookieData.listTravelDoc[0].docNum || null);
						this.personalDocsComp.form.controls['country'].setValue(paxCookieData.listTravelDoc[0].country || null);
						this.personalDocsComp.form.controls['expiryDate'].setValue(paxCookieData.listTravelDoc[0].expiryDate || null);
						this.personalDocsComp.form.controls['lifelong'].setValue(paxCookieData.listTravelDoc[0].lifelong || false);
					}

					this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateDocument': true }));
				}
				// emergency contact form
				if (paxCookieData.emergencyData !== null && (paxCookieData.emergencyData.declined !== null || !paxCookieData.emergencyData.declined)) {
					if (this.componentAndFormExists(this.emergencyContactComp)) {
						this.emergencyContactComp.form.controls['emCountry'].setValue(paxCookieData.emergencyData.emCountry || null);
						this.emergencyContactComp.form.controls['emName'].setValue(paxCookieData.emergencyData.emName || null);
						this.emergencyContactComp.form.controls['emPhone'].setValue(paxCookieData.emergencyData.emPhone || null);
						this.emergencyContactComp.form.controls['emPrefix'].setValue(paxCookieData.emergencyData.emPrefix || null);
						this.emergencyContactComp.form.controls['declined'].setValue(paxCookieData.emergencyData.declined || null);

						this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateEmergencyContact': true }));
					}
				}

				// frequent flyer form
				if (this.componentAndFormExists(this.frequentFlyerComp)) {
					this.frequentFlyerComp.form.controls['FFid'].setValue(paxCookieData.FFid || null);
					this.frequentFlyerComp.form.controls['FFnum'].setValue(paxCookieData.FFnum || '');

					this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateFrequentFlyer': true }));
				}

				// contact num
				/*
				this.passengerContactsComp.form.controls['phoneCountryCode'].setValue(paxCookieData.phoneCountryCode  || null);
				this.passengerContactsComp.form.controls['phone'].setValue(paxCookieData.phone || '');
				this.passengerContactsComp.form.controls['email'].setValue(paxCookieData.email || '');
				this.passengerContactsComp.form.controls['phoneType'].setValue(paxCookieData.phoneType || '');
				this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateContact': true }));
				*/

				// student form
				if (this.componentAndFormExists(this.passengerStudentComp)) {
					this.passengerStudentComp.form.controls['studentDocNumber'].setValue(paxCookieData.studentDocNumber || '');
					this.passengerStudentComp.form.controls['studentfiscalNumber'].setValue(paxCookieData.studentfiscalNumber || '');

					this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateStudentInfo': true }));
				}

				// resident form
				if (this.componentAndFormExists(this.passengerResidentComp)) {
					this.passengerResidentComp.form.controls['residentDocNumber'].setValue(paxCookieData.residentDocNumber || '');
					this.passengerResidentComp.form.controls['residentfiscalNumber'].setValue(paxCookieData.residentfiscalNumber || '');

					this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateResidentInfo': true }));
				}
				// travel insurance form
				if (this.componentAndFormExists(this.passengerTravelInsuranceComp)) {
					this.passengerTravelInsuranceComp.form.controls['vatNumber'].setValue(paxCookieData.travelInsurance.vatNumber || '');
					this.passengerTravelInsuranceComp.form.controls['address'].setValue(paxCookieData.travelInsurance.address || '');
					this.passengerTravelInsuranceComp.form.controls['zipcode'].setValue(paxCookieData.travelInsurance.zipcode || '');
					this.passengerTravelInsuranceComp.form.controls['city'].setValue(paxCookieData.travelInsurance.city || '');

					this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateTravelInsurance': true }));
				}

				this.hasImportedData = true;
			} else {
				// main info form
				if (this.userData.userProfile && (this.userData.userProfile.title ||
					this.userData.userProfile.firstName || this.userData.userProfile.lastName ||
					this.userData.userProfile.gender || this.userData.userProfile.dateOfBirth)) {

          // Can add more mapping in the future
          const genderMapping = {
            male: ['Mr', 'Sr'],
            female: ['Mrs', 'Sra']
          }
					const title = genderMapping.male.includes(this.userData.userProfile.title) ? 'Mr' : 
            genderMapping.female.includes(this.userData.userProfile.title) ? 'Mrs' : null;

					this.passengerMainInfoComp.form.controls['name'].setValue(this.userData.userProfile.firstName || '');
					this.passengerMainInfoComp.form.controls['surname'].setValue(this.userData.userProfile.lastName || '');

					if (this.passengerMainInfoComp.form.controls['title']) {
						this.passengerMainInfoComp.form.controls['title'].setValue(title || null);
					}
					if (this.passengerMainInfoComp.form.controls['gender']) {
						this.passengerMainInfoComp.form.controls['gender'].setValue(this.userData.userProfile.gender || null);
					}
					if (this.passengerMainInfoComp.form.controls['birthDate']) {
						this.passengerMainInfoComp.form.controls['birthDate'].setValue(this.userData.userProfile.dateOfBirth || null);
					}

					this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateMainInfo': true }));
					if (this.userData.userProfile.gender || this.userData.userProfile.dateOfBirth) {
						this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateDocument': true }));
					}
					this.hasImportedData = true;
				}

				// personal travel document form
				if (this.userData.userProfile && (this.userData.userProfile.country ||
					this.userData.userProfile.dateOfBirth || this.userData.userProfile.gender)) {

					if (this.componentAndFormExists(this.personalDocsComp)) {
						if (this.personalDocsComp.form.controls['gender']) {
							this.personalDocsComp.form.controls['gender'].setValue(this.userData.userProfile.gender || null);
						}
						if (this.personalDocsComp.form.controls['birthDate']) {
							this.personalDocsComp.form.controls['birthDate'].setValue(this.userData.userProfile.dateOfBirth || null);
						}

						if (this.userData.travelDocument) {
							if (!(this.isUKDestination && this.userData.travelDocument.documentType === DOCUMENT_NUMBER_NATIONAL_IDENTITY_CARD)) {
								if (this.personalDocsComp.form.controls['docNum']) {
									this.personalDocsComp.form.controls['docNum'].setValue(this.userData.travelDocument.number || null);
								}
								if (this.personalDocsComp.form.controls['docType']) {
									this.personalDocsComp.form.controls['docType'].setValue(this.userData.travelDocument.documentType || null);
								}
								if (this.personalDocsComp.form.controls['expiryDate']) {
									this.personalDocsComp.form.controls['expiryDate'].setValue(this.userData.travelDocument.expirationDate || null);
								}
								if (this.personalDocsComp.form.controls['country']) {
									this.personalDocsComp.form.controls['country'].setValue(this.userData.userProfile.travelDocument.country || null);
								}
							}
						}
						if (this.personalDocsComp.form.controls['nationallity']) {
							this.personalDocsComp.form.controls['nationallity'].setValue(this.userData.country || null);
						}

						this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateDocument': true }));
						this.hasImportedData = true;
					}
				}

				// frequent flyer form
				if (this.userData.userProfile && (this.userData.userProfile.ffCarrier || this.userData.userProfile.ffNumber)) {
					if (this.componentAndFormExists(this.frequentFlyerComp)) {
						this.frequentFlyerComp.form.controls['FFid'].setValue(this.userData.userProfile.ffCarrier || null);
						this.frequentFlyerComp.form.controls['FFnum'].setValue(this.userData.userProfile.ffNumber || '');

						this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateFrequentFlyer': true }));
						this.hasImportedData = true;
					}
				}

				// contact form
				/*
				if (this.userData.userProfile && ((this.userData.userProfile.contactPhone &&
					(this.userData.userProfile.contactPhone.countryCode || this.userData.userProfile.contactPhone.number)) ||
					this.userData.userProfile.contactEmail)) {

					if (this.userData.userProfile.contactPhone && this.userData.userProfile.contactPhone.countryCode) {
						const phoneCountryCode = this.convertToCountryCodeFormat(this.userData.userProfile.contactPhone.countryCode);
						this.passengerContactsComp.form.controls['phoneCountryCode'].setValue(phoneCountryCode || null);
					}
					
					if (this.userData.userProfile.contactPhone) {
						this.passengerContactsComp.form.controls['phone'].setValue(this.userData.userProfile.contactPhone.number || '');
					}
					
					this.passengerContactsComp.form.controls['email'].setValue(this.userData.userProfile.contactEmail || '');

					this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateContact': true }));
					this.hasImportedData = true;
				}
				*/
			}
		}
	}


	INDRA_getTextTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}

	private convertToCountryCodeFormat(str) {
		if (str) {
			const countryCode = Number(str).toString();
			return '+' + countryCode;
		}

		return null;
	}

	INDRA_handleReset() {
		// main info form
		if (this.componentAndFormExists(this.passengerMainInfoComp)) {
			this.passengerMainInfoComp.form.controls['name'].setValue('');
			this.passengerMainInfoComp.form.controls['surname'].setValue('');
			this.passengerMainInfoComp.form.controls['title'].setValue(null);
			this.passengerMainInfoComp.form.controls['gender'].setValue(null);
			this.passengerMainInfoComp.form.controls['birthDate'].setValue(null);

			this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateMainInfo': true }));
		}
		// emergency contact form
		if (this.componentAndFormExists(this.emergencyContactComp)) {
			this.emergencyContactComp.form.controls['emCountry'].setValue(null);
			this.emergencyContactComp.form.controls['emName'].setValue(null);
			this.emergencyContactComp.form.controls['emPhone'].setValue(null);
			this.emergencyContactComp.form.controls['emPrefix'].setValue(null);
			this.emergencyContactComp.form.controls['declined'].setValue(null);

			this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateEmergencyContact': true }));
		}
		// personal travel document form
		if (this.componentAndFormExists(this.personalDocsComp)) {
			this.personalDocsComp.form.controls['country'].setValue(null);
			this.personalDocsComp.form.controls['gender'].setValue(null);
			this.personalDocsComp.form.controls['birthDate'].setValue(null);
			this.personalDocsComp.form.controls['expiryDate'].setValue(null);
			this.personalDocsComp.form.controls['lifelong'].setValue(false);
			this.personalDocsComp.form.controls['docNum'].setValue(null);
			this.personalDocsComp.form.controls['docType'].setValue(null);
			this.personalDocsComp.form.controls['nationallity'].setValue(null);

			this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateDocument': true }));
		}
		// frequent flyer form
		if (this.componentAndFormExists(this.frequentFlyerComp)) {
			this.frequentFlyerComp.form.controls['FFid'].setValue(null);
			this.frequentFlyerComp.form.controls['FFnum'].setValue('');

			this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateFrequentFlyer': true }));
		}
		// contact num
		/*
		if (this.componentAndFormExists(this.passengerContactsComp)) {
			this.passengerContactsComp.form.controls['phoneCountryCode'].setValue(null);
			this.passengerContactsComp.form.controls['phone'].setValue('');
			this.passengerContactsComp.form.controls['email'].setValue('');
			this.passengerContactsComp.form.controls['phoneType'].setValue('');

			this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateContact': true }));
		}
		*/

		// student form
		if (this.componentAndFormExists(this.passengerStudentComp)) {
			this.passengerStudentComp.form.controls['studentDocNumber'].setValue('');
			this.passengerStudentComp.form.controls['studentfiscalNumber'].setValue('');

			this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateStudentInfo': true }));
		}
		// resident form
		if (this.componentAndFormExists(this.passengerResidentComp)) {
			this.passengerResidentComp.form.controls['residentDocNumber'].setValue('');
			this.passengerResidentComp.form.controls['residentfiscalNumber'].setValue('');

			this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateResidentInfo': true }));
		}
		// travel insurance form
		if (this.componentAndFormExists(this.passengerTravelInsuranceComp)) {
			this.passengerTravelInsuranceComp.form.controls['vatNumber'].setValue('');
			this.passengerTravelInsuranceComp.form.controls['address'].setValue('');
			this.passengerTravelInsuranceComp.form.controls['zipcode'].setValue('');
			this.passengerTravelInsuranceComp.form.controls['city'].setValue('');

			this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateTravelInsurance': true }));
		}
	}

	INDRA_isSaved() {
		return this.saved === 'true';
	}

	INDRA_handleDeleteCookies() {
		this.cookieService.delete(COOKIES_VAR_KEY_PASSENGER_DETAILS, '/booking');
		this.cookieService.delete(COOKIES_VAR_KEY_PASSENGER_CONTACT_DETAILS, '/booking');
		this.hasCookies = false;
	}


	INDRA_getDepartureDate() {
		if (this.bookedTrip && this.bookedTrip.data && this.bookedTrip.data) {
			if (this.bookedTrip.data.fare.tripType == TRIP_TYPE_ROUND_TRIP && this.bookedTrip.data.fare.listInbound.length > 0) {
				return this.bookedTrip.data.fare.listInbound[this.bookedTrip.data.fare.listInbound.length - 1].lastSegment.departureDate;
			}

			else if ((this.bookedTrip.data.fare.tripType == TRIP_TYPE_ONE_WAY || this.bookedTrip.data.fare.tripType == TRIP_TYPE_MULTICITY) && this.bookedTrip.data.fare.listOutbound.length > 0) {


				return this.bookedTrip.data.fare.listOutbound[this.bookedTrip.data.fare.listOutbound.length - 1].lastSegment.departureDate;
			}
		}
	}

	INDRA_scrollToElement(element) {
		const elementWithError = element;
		elementWithError.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
	}

	// INDRA_showTravelInsuranceForm() {
	// 	let market = sessionStorage.getItem('market');
	// 	return INSURANCE_INFO_REQUIRED_MARKETS.includes(market)
	// }

	INDRA_isUKDestination(bookedTripFare) {
		let isUKDestination = false;
		isUKDestination = [
			...bookedTripFare.listOutbound.map(lo => lo.listSegment.map(ls => ls.arrivalAirport)),
			...bookedTripFare.listInbound.map(li => li.listSegment.map(ls => ls.arrivalAirport))
		].some(destination => this.locations.some(loc => destination.includes(loc.code) && loc.countryCode === COUNTRY_CODE_UNITED_KINGDOM));

		this.isUKDestination = isUKDestination;
	}

	INDRA_updateBeneficiaryData(event) {
		this.INDRA_handleReset();
		// If the passenger being edited was new, and now the user is selecting a beneficiary from the list
		if (this.isNew && this.edit) {
			this.numberOfBeneficiaries = Number(this.numberOfBeneficiaries) - 1;
			this.beneficiaryService.setNumberOfBeneficiaries(this.numberOfBeneficiaries);
		}
		this.passengerMainInfoComp.form.controls['isNew'].setValue(false);
		if (event.target.value.toLowerCase() == PAX_TYPE_SPONSOR.toLowerCase()) {
			this.beneficiarySelected = event.target.value;
			this.INDRA_importUserData(this.userData);
			// this.INDRA_disableFormFields();
		} else {
			this.beneficiarySelected = event.target.value;
			this.passengerMainInfoComp.form.controls['name'].setValue(this.beneficiaryList[this.beneficiarySelected].personName[0].givenName[0]);
			this.passengerMainInfoComp.form.controls['surname'].setValue(this.beneficiaryList[this.beneficiarySelected].personName[0].surname);
			this.passengerMainInfoComp.form.controls['title'].setValue(this.beneficiaryService.INDRA_formatCapitalization(this.beneficiaryList[this.beneficiarySelected].personName[0].namePrefix[0]));
			if (PAX_TYPE_CHILD_CODE == this.passengerInfo.typePax) {
				this.passengerMainInfoComp.form.controls['gender'].setValue(this.beneficiaryService.INDRA_formatCapitalization(this.beneficiaryService.INDRA_getGenderFromSalutation(this.paxSalutations, this.beneficiaryList[this.beneficiarySelected].personName[0].namePrefix[0])));
				this.passengerMainInfoComp.form.controls['gender'].disable();
			}
			// this.INDRA_disableFormFields();
		}
	}

	/*INDRA_markBeneficiaryAsUsed() {
		let beneficiaryNamesAux = [];
		this.beneficiaryNames.forEach(beneficiary => {
			if (beneficiary.value == this.beneficiarySelected) {
				beneficiary.disabled = true;
			}
			beneficiaryNamesAux.push(beneficiary);
		});
		this.beneficiaryNames = beneficiaryNamesAux;
	}*/

	INDRA_unmarkBeneficiaryAsUsed(passengerName) {
		this.beneficiaryListSubscription = this.beneficiaryService.currentPassengers$.subscribe(passengers => {
			// First discriminate by typepax
			let beneficiaryNamesAux1 = [];
			this.beneficiaryNames.forEach(beneficiary => {
				if (beneficiary.type == passengers[Number(this.idPax) - 1].typePax) {
					beneficiary.disabled = false;
				} else {
					beneficiary.disabled = true;
				}
				beneficiaryNamesAux1.push(beneficiary);
			});
			this.beneficiaryNames = beneficiaryNamesAux1;

			// Second discriminate by same name
			/*let beneficiaryNamesAux2 = [];
			this.beneficiaryNames.forEach(beneficiary => {
				if (beneficiary.label.toLowerCase().includes(passengerName.toLowerCase())) {
					beneficiary.disabled = false;
				}
				beneficiaryNamesAux2.push(beneficiary);
			});
			this.beneficiaryNames = beneficiaryNamesAux2;*/
		});
	}

	INDRA_matchesNames(): void {
		let validator = false;
		let beneficiaryValidator: boolean = false;
		let passengerValidator: boolean = false;
		let sponsorValidator: boolean = false;

		// If typePax is CHD, the title input (salutation) is undefined
		let gender: string = '';
		if (this.passengerInfo.typePax == PAX_TYPE_CHILD_CODE) {
			gender = this.passengerMainInfoComp.form.controls['gender'].value;
		} else {
			gender = this.beneficiaryService.INDRA_getGenderFromSalutation(this.paxSalutations, this.passengerMainInfoComp.form.controls['title'].value)
		}

		// The sponsor can't be CHD or INF, must be ADT
		sponsorValidator = (
			this.passengerMainInfoComp.form.controls['name'].value.toUpperCase() == this.userData.firstName.toUpperCase() &&
			this.passengerMainInfoComp.form.controls['surname'].value.toUpperCase() == this.userData.lastName.toUpperCase() &&
			this.passengerInfo.typePax == PAX_TYPE_ADULT_CODE &&
			gender.toUpperCase() == this.beneficiaryService.INDRA_getGenderFromSalutation(this.paxSalutations, this.userData.title).toUpperCase()
		);

		this.beneficiaryListSubscription = this.beneficiaryService.currentPassengers$.subscribe(passengers => {
			this.passengers = passengers
			// Validates against beneficiary list
			beneficiaryValidator = this.beneficiaryList.some(beneficiary => {
				return (
					this.passengerMainInfoComp.form.controls['name'].value.toUpperCase() == beneficiary.personName[0].givenName[0].toUpperCase() &&
					this.passengerMainInfoComp.form.controls['surname'].value.toUpperCase() == beneficiary.personName[0].surname.toUpperCase() &&
					this.passengerInfo.typePax == this.beneficiaryService.INDRA_getTypePaxFromSalutation(this.paxSalutations, beneficiary.personName[0].namePrefix[0]) &&
					gender.toUpperCase() == this.beneficiaryService.INDRA_getGenderFromSalutation(this.paxSalutations, beneficiary.personName[0].namePrefix[0]).toUpperCase()
				);
			});
			// Validates against current passengers on the flight
			passengerValidator = this.passengers.some(passenger => {
				if (passenger.title != null) {
					return (
						this.passengerMainInfoComp.form.controls['name'].value.toUpperCase() == passenger.name.toUpperCase() &&
						this.passengerMainInfoComp.form.controls['surname'].value.toUpperCase() == passenger.surname.toUpperCase() &&
						this.passengerInfo.typePax == passenger.typePax &&
						gender.toUpperCase() == this.beneficiaryService.INDRA_getGenderFromSalutation(this.paxSalutations, passenger.title).toUpperCase()
					);
				}
			});
		});

		validator = (sponsorValidator || beneficiaryValidator || passengerValidator);
		this.passengerMainInfoComp.form.controls['isNew'].setValue(!validator);
	}

	INDRA_receiveBeneficiaryNames() {
		this.beneficiaryListSubscription = this.beneficiaryService.currentBeneficiaryNames$.subscribe(beneficiaryNames => {
			let beneficiaryNamesAux = [];
			let flag: boolean = false;
			while (!flag) {
				if (beneficiaryNames == undefined || (beneficiaryNames.length == 0 && (Number(this.numberOfBeneficiaries) + 1) > 1)) {
					flag = false;
				} else {
					if (beneficiaryNames && beneficiaryNames.length > 0) {
						beneficiaryNames.forEach(beneficiary => {
							if (beneficiary.type.toLowerCase() != this.passengerInfo.typePax.toLowerCase()) {
								beneficiary.disabled = true;
							}
							beneficiaryNamesAux.push(beneficiary);
						});
					}
					flag = true;
				}
			}
			this.beneficiaryNames = beneficiaryNamesAux;
		});
	}

	INDRA_disableFormFields() {
		if (this.componentAndFormExists(this.passengerMainInfoComp)) {
			this.passengerMainInfoComp.form.controls['name'].disable();
			this.passengerMainInfoComp.form.controls['surname'].disable();
			this.passengerMainInfoComp.form.controls['title'].disable();
			this.passengerMainInfoComp.form.controls['gender'].disable();

			this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateMainInfo': true }));
		}
	}

	INDRA_enableFormFields() {
		if (this.componentAndFormExists(this.passengerMainInfoComp)) {
			this.passengerMainInfoComp.form.controls['name'].enable();
			this.passengerMainInfoComp.form.controls['surname'].enable();
			this.passengerMainInfoComp.form.controls['title'].enable();
			this.passengerMainInfoComp.form.controls['gender'].enable();

			this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateMainInfo': true }));
		}
	}

	INDRA_clearBeneficiaryFields() {
		this.INDRA_enableFormFields();
		this.INDRA_handleReset();
		this.isReset = true;
		this.beneficiarySelected = null;
	}

	INDRA_onReset(event) {
		this.isReset = event;
	}
}
